export default __webpack_public_path__ + "static/media/languages.dcc7582f.png";